import { render } from "./QuestionExamplePhoneticConsonant.vue?vue&type=template&id=35e03396&scoped=true"
import script from "./QuestionExamplePhoneticConsonant.vue?vue&type=script&lang=js"
export * from "./QuestionExamplePhoneticConsonant.vue?vue&type=script&lang=js"

import "@/css/components/question-example-phonetic-consonant.css?vue&type=style&index=0&id=35e03396&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35e03396"]])

export default __exports__